export default [{
  path: '/verificacion-de-compra',
  name: 'shopping-confirmation',
  component: function component() {
    return import('pages/process/Index.vue');
  }
}, {
  path: '/proceso-de-compra',
  name: 'shopping-process',
  component: function component() {
    return import('pages/process/PaymentSteps.vue');
  },
  meta: {
    auth: true
  }
}, {
  path: '/order/:id?',
  name: 'order',
  component: function component() {
    return import('pages/process/Order.vue');
  }
}, {
  path: '/confirmacion-de-compra',
  name: 'confirmation',
  component: function component() {
    return import('pages/process/Confirmation.vue');
  }
}, {
  path: 'confirmacion-paypal',
  name: 'confirmacion-paypal',
  component: function component() {
    return import('pages/process/ConfirmationPaypal.vue');
  }
}, {
  path: 'cancel-paypal',
  name: 'cancel-paypal',
  component: function component() {
    return import('pages/process/CancelPaypal.vue');
  },
  meta: {
    auth: true
  }
}];